<script>
    import {_} from 'svelte-i18n';
    import PackListing from '../PackListing.svelte';
    import {onMount} from 'svelte';
    import {goTo} from "../../utils.js";

    onMount(() => {
        window.scrollTo(0, 0);
        goTo('/supplies/welcomeBackPacks', true);
    });
</script>

<PackListing storeSection="welcomeBackPacks" title={$_('NewShopTabWelcomeBack')}/>
